var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"text-center"},[_vm._v(" We no longer support credit card payments on total charges over $5,000. Please consider another option of payment such as check or ACH payment. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }